export const AVG_BUY_PRICES = [
  {
    mittl_preis_qm_kauf: 2254.828257,
    min_preis_qm_kauf: 1090.030029,
    max_preis_qm_kauf: 3650,
    name: 'Neukölln',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 3471.528183,
    min_preis_qm_kauf: 1500,
    max_preis_qm_kauf: 6317.339844,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 2347.124011,
    min_preis_qm_kauf: 1220.109985,
    max_preis_qm_kauf: 3886.209961,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 1922.543261,
    min_preis_qm_kauf: 1000,
    max_preis_qm_kauf: 3561.639893,
    name: 'Reinickendorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 3943.189288,
    min_preis_qm_kauf: 1461.459961,
    max_preis_qm_kauf: 7183.910156,
    name: 'Mitte',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 1566.946753,
    min_preis_qm_kauf: 988.1400146,
    max_preis_qm_kauf: 2835.219971,
    name: 'Spandau',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 1665.317724,
    min_preis_qm_kauf: 1016.630005,
    max_preis_qm_kauf: 2995.620117,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 2862.765054,
    min_preis_qm_kauf: 1413.119995,
    max_preis_qm_kauf: 5196.060059,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 2215.513102,
    min_preis_qm_kauf: 1196.319946,
    max_preis_qm_kauf: 3594.590088,
    name: 'Lichtenberg',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 2415.868363,
    min_preis_qm_kauf: 1234.119995,
    max_preis_qm_kauf: 4342.319824,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 3502.623609,
    min_preis_qm_kauf: 1757.5,
    max_preis_qm_kauf: 5997.350098,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 2937.572069,
    min_preis_qm_kauf: 1550,
    max_preis_qm_kauf: 5022.069824,
    name: 'Pankow',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_kauf: 2347.019914,
    min_preis_qm_kauf: 1177.170044,
    max_preis_qm_kauf: 3750,
    name: 'Neukölln',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 3750.127071,
    min_preis_qm_kauf: 1718.75,
    max_preis_qm_kauf: 6828.120117,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 2400.094664,
    min_preis_qm_kauf: 1235.290039,
    max_preis_qm_kauf: 4005.040039,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 1987.770429,
    min_preis_qm_kauf: 1138.890015,
    max_preis_qm_kauf: 3593.320068,
    name: 'Reinickendorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 4068.220873,
    min_preis_qm_kauf: 1540.130005,
    max_preis_qm_kauf: 7899.790039,
    name: 'Mitte',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 1671.250642,
    min_preis_qm_kauf: 1017.859985,
    max_preis_qm_kauf: 3055.639893,
    name: 'Spandau',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 1853.830852,
    min_preis_qm_kauf: 1034.47998,
    max_preis_qm_kauf: 3550.550049,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 2977.857232,
    min_preis_qm_kauf: 1484.670044,
    max_preis_qm_kauf: 5294.049805,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 2313.290259,
    min_preis_qm_kauf: 1262.699951,
    max_preis_qm_kauf: 3600,
    name: 'Lichtenberg',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 2653.406546,
    min_preis_qm_kauf: 1269.25,
    max_preis_qm_kauf: 4682.759766,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 3607.95573,
    min_preis_qm_kauf: 1995.939941,
    max_preis_qm_kauf: 6000,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 3015.885963,
    min_preis_qm_kauf: 1619.829956,
    max_preis_qm_kauf: 5322.689941,
    name: 'Pankow',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_kauf: 2298.730958,
    min_preis_qm_kauf: 1160.180054,
    max_preis_qm_kauf: 3937.5,
    name: 'Neukölln',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 3835.264985,
    min_preis_qm_kauf: 1846.150024,
    max_preis_qm_kauf: 7162.439941,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 2426.112482,
    min_preis_qm_kauf: 1298.959961,
    max_preis_qm_kauf: 4324.970215,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 2019.16372,
    min_preis_qm_kauf: 1199.890015,
    max_preis_qm_kauf: 3466.25,
    name: 'Reinickendorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 4014.9905,
    min_preis_qm_kauf: 1428.569946,
    max_preis_qm_kauf: 7785.709961,
    name: 'Mitte',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 1698.669024,
    min_preis_qm_kauf: 1038.869995,
    max_preis_qm_kauf: 3104.790039,
    name: 'Spandau',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 1951.137018,
    min_preis_qm_kauf: 1095.23999,
    max_preis_qm_kauf: 3753.139893,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 3133.895379,
    min_preis_qm_kauf: 1606.170044,
    max_preis_qm_kauf: 5757.580078,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 2337.070862,
    min_preis_qm_kauf: 1226.800049,
    max_preis_qm_kauf: 3975,
    name: 'Lichtenberg',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 2679.114361,
    min_preis_qm_kauf: 1254.76001,
    max_preis_qm_kauf: 4756.609863,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 3650.092302,
    min_preis_qm_kauf: 1950.01001,
    max_preis_qm_kauf: 6038.399902,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 3114.592122,
    min_preis_qm_kauf: 1692.310059,
    max_preis_qm_kauf: 5444.439941,
    name: 'Pankow',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_kauf: 2430.727514,
    min_preis_qm_kauf: 1320.75,
    max_preis_qm_kauf: 3982.300049,
    name: 'Neukölln',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 3901.496265,
    min_preis_qm_kauf: 1935.189941,
    max_preis_qm_kauf: 7575.759766,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 2607.44411,
    min_preis_qm_kauf: 1384.180054,
    max_preis_qm_kauf: 4538.459961,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 2084.073784,
    min_preis_qm_kauf: 1249.47998,
    max_preis_qm_kauf: 3369.889893,
    name: 'Reinickendorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 4229.324888,
    min_preis_qm_kauf: 1691.349976,
    max_preis_qm_kauf: 8401,
    name: 'Mitte',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 1777.676221,
    min_preis_qm_kauf: 1057.140015,
    max_preis_qm_kauf: 3220.48999,
    name: 'Spandau',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 1964.850775,
    min_preis_qm_kauf: 1150,
    max_preis_qm_kauf: 3304.550049,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 3134.675175,
    min_preis_qm_kauf: 1610.130005,
    max_preis_qm_kauf: 5823.259766,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 2488.991976,
    min_preis_qm_kauf: 1267.609985,
    max_preis_qm_kauf: 4264.52002,
    name: 'Lichtenberg',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 2820.332998,
    min_preis_qm_kauf: 1421.079956,
    max_preis_qm_kauf: 5000,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 3808.614102,
    min_preis_qm_kauf: 1998.069946,
    max_preis_qm_kauf: 6034.370117,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 3280.139836,
    min_preis_qm_kauf: 1700,
    max_preis_qm_kauf: 5760.299805,
    name: 'Pankow',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_kauf: 2645.799731,
    min_preis_qm_kauf: 1439.829956,
    max_preis_qm_kauf: 4423.080078,
    name: 'Neukölln',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 3899.649959,
    min_preis_qm_kauf: 1989.540039,
    max_preis_qm_kauf: 7492.419922,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 2640.054535,
    min_preis_qm_kauf: 1450.550049,
    max_preis_qm_kauf: 4541.600098,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 2206.668392,
    min_preis_qm_kauf: 1361.109985,
    max_preis_qm_kauf: 3555.560059,
    name: 'Reinickendorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 4265.538156,
    min_preis_qm_kauf: 1709.089966,
    max_preis_qm_kauf: 8300,
    name: 'Mitte',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 1883.566477,
    min_preis_qm_kauf: 1038.869995,
    max_preis_qm_kauf: 3472.350098,
    name: 'Spandau',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 2008.048044,
    min_preis_qm_kauf: 1189.079956,
    max_preis_qm_kauf: 3278.600098,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 3108.68576,
    min_preis_qm_kauf: 1611.939941,
    max_preis_qm_kauf: 5723.040039,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 2600.809209,
    min_preis_qm_kauf: 1277.650024,
    max_preis_qm_kauf: 4371.430176,
    name: 'Lichtenberg',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 2984.81261,
    min_preis_qm_kauf: 1545.449951,
    max_preis_qm_kauf: 5188.310059,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 3913.900135,
    min_preis_qm_kauf: 2098.73999,
    max_preis_qm_kauf: 6087.02002,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 3432.794759,
    min_preis_qm_kauf: 1803.75,
    max_preis_qm_kauf: 5823.529785,
    name: 'Pankow',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_kauf: 2754.473554,
    min_preis_qm_kauf: 1390.630005,
    max_preis_qm_kauf: 4500,
    name: 'Neukölln',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 4013.582595,
    min_preis_qm_kauf: 2066.649902,
    max_preis_qm_kauf: 7995.450195,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 2661.041207,
    min_preis_qm_kauf: 1492.310059,
    max_preis_qm_kauf: 4521.689941,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 2261.490485,
    min_preis_qm_kauf: 1451.459961,
    max_preis_qm_kauf: 3555.560059,
    name: 'Reinickendorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 4428.000384,
    min_preis_qm_kauf: 1840.859985,
    max_preis_qm_kauf: 9079.19043,
    name: 'Mitte',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 2005.68417,
    min_preis_qm_kauf: 1099.170044,
    max_preis_qm_kauf: 3542.860107,
    name: 'Spandau',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 2041.399796,
    min_preis_qm_kauf: 1197.050049,
    max_preis_qm_kauf: 3265.110107,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 3185.364577,
    min_preis_qm_kauf: 1665.969971,
    max_preis_qm_kauf: 5900,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 2625.515289,
    min_preis_qm_kauf: 1304.219971,
    max_preis_qm_kauf: 4296.700195,
    name: 'Lichtenberg',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 3108.692738,
    min_preis_qm_kauf: 1598.73999,
    max_preis_qm_kauf: 5250.109863,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 3933.451315,
    min_preis_qm_kauf: 2201.780029,
    max_preis_qm_kauf: 6387.649902,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 3518.065327,
    min_preis_qm_kauf: 1864,
    max_preis_qm_kauf: 5951.040039,
    name: 'Pankow',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_kauf: 3024.730382,
    min_preis_qm_kauf: 1480.26001,
    max_preis_qm_kauf: 5538.459961,
    name: 'Neukölln',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 4129.849315,
    min_preis_qm_kauf: 2100.050049,
    max_preis_qm_kauf: 7962.959961,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 2625.620274,
    min_preis_qm_kauf: 1526.319946,
    max_preis_qm_kauf: 4510.52002,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 2361.13901,
    min_preis_qm_kauf: 1613.189941,
    max_preis_qm_kauf: 3650,
    name: 'Reinickendorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 4564.93331,
    min_preis_qm_kauf: 1844.619995,
    max_preis_qm_kauf: 9085.830078,
    name: 'Mitte',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 2161.416656,
    min_preis_qm_kauf: 1244.369995,
    max_preis_qm_kauf: 3916.669922,
    name: 'Spandau',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 2155.138869,
    min_preis_qm_kauf: 1089.780029,
    max_preis_qm_kauf: 3461.540039,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 3285.680126,
    min_preis_qm_kauf: 1747.880005,
    max_preis_qm_kauf: 5764.709961,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 2962.333782,
    min_preis_qm_kauf: 1305.189941,
    max_preis_qm_kauf: 5023.259766,
    name: 'Lichtenberg',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 3237.477225,
    min_preis_qm_kauf: 1637.930054,
    max_preis_qm_kauf: 5750,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 4035.587984,
    min_preis_qm_kauf: 2413.129883,
    max_preis_qm_kauf: 6487.459961,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 3628.035754,
    min_preis_qm_kauf: 1867.650024,
    max_preis_qm_kauf: 6011.970215,
    name: 'Pankow',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_kauf: 3121.001735,
    min_preis_qm_kauf: 1616.300049,
    max_preis_qm_kauf: 5566.040039,
    name: 'Neukölln',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 4219.024882,
    min_preis_qm_kauf: 2263.159912,
    max_preis_qm_kauf: 8000,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 2724.349232,
    min_preis_qm_kauf: 1554.849976,
    max_preis_qm_kauf: 5128.569824,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 2351.317613,
    min_preis_qm_kauf: 1641.780029,
    max_preis_qm_kauf: 3888.889893,
    name: 'Reinickendorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 4820.634164,
    min_preis_qm_kauf: 1916.030029,
    max_preis_qm_kauf: 9734.509766,
    name: 'Mitte',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 2255.746523,
    min_preis_qm_kauf: 1355.930054,
    max_preis_qm_kauf: 4051.340088,
    name: 'Spandau',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 2303.572824,
    min_preis_qm_kauf: 1221.900024,
    max_preis_qm_kauf: 4000,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 3341.978239,
    min_preis_qm_kauf: 1783.859985,
    max_preis_qm_kauf: 5800,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 3439.532836,
    min_preis_qm_kauf: 1390.910034,
    max_preis_qm_kauf: 5200,
    name: 'Lichtenberg',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 3299.047408,
    min_preis_qm_kauf: 1680.97998,
    max_preis_qm_kauf: 5879.52002,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 4133.185642,
    min_preis_qm_kauf: 2490.530029,
    max_preis_qm_kauf: 6785.930176,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 3752.100656,
    min_preis_qm_kauf: 2026.069946,
    max_preis_qm_kauf: 6300,
    name: 'Pankow',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_kauf: 3169.963188,
    min_preis_qm_kauf: 1777.380005,
    max_preis_qm_kauf: 5281.689941,
    name: 'Neukölln',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 4235.304084,
    min_preis_qm_kauf: 2363.639893,
    max_preis_qm_kauf: 8040.200195,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 2842.047759,
    min_preis_qm_kauf: 1609.310059,
    max_preis_qm_kauf: 5336.549805,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 2385.031876,
    min_preis_qm_kauf: 1681.180054,
    max_preis_qm_kauf: 3713.899902,
    name: 'Reinickendorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 4889.159831,
    min_preis_qm_kauf: 2112,
    max_preis_qm_kauf: 9734.509766,
    name: 'Mitte',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 2306.80277,
    min_preis_qm_kauf: 1476.560059,
    max_preis_qm_kauf: 4051.340088,
    name: 'Spandau',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 2420.700153,
    min_preis_qm_kauf: 1168.829956,
    max_preis_qm_kauf: 4220.339844,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 3393.839869,
    min_preis_qm_kauf: 1774.550049,
    max_preis_qm_kauf: 5825,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 3226.594668,
    min_preis_qm_kauf: 1459.329956,
    max_preis_qm_kauf: 5045.450195,
    name: 'Lichtenberg',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 3355.530668,
    min_preis_qm_kauf: 1741.939941,
    max_preis_qm_kauf: 5879.52002,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 4331.638201,
    min_preis_qm_kauf: 2630.26001,
    max_preis_qm_kauf: 7357.549805,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 3937.755436,
    min_preis_qm_kauf: 2152.790039,
    max_preis_qm_kauf: 6318.180176,
    name: 'Pankow',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_kauf: 3341.793641,
    min_preis_qm_kauf: 1791.530029,
    max_preis_qm_kauf: 5298.75,
    name: 'Neukölln',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 4346.422606,
    min_preis_qm_kauf: 2452.01001,
    max_preis_qm_kauf: 8125,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 2987.313623,
    min_preis_qm_kauf: 1714.290039,
    max_preis_qm_kauf: 5336.549805,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 2508.965839,
    min_preis_qm_kauf: 1671.430054,
    max_preis_qm_kauf: 3997.719971,
    name: 'Reinickendorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 5051.168107,
    min_preis_qm_kauf: 2307.689941,
    max_preis_qm_kauf: 9660.19043,
    name: 'Mitte',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 2445.007137,
    min_preis_qm_kauf: 1534.47998,
    max_preis_qm_kauf: 4458.779785,
    name: 'Spandau',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 2664.153307,
    min_preis_qm_kauf: 1538.76001,
    max_preis_qm_kauf: 4242.419922,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 3581.483178,
    min_preis_qm_kauf: 1805.430054,
    max_preis_qm_kauf: 5958.339844,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 3439.162627,
    min_preis_qm_kauf: 1759.290039,
    max_preis_qm_kauf: 5045.450195,
    name: 'Lichtenberg',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 3522.517911,
    min_preis_qm_kauf: 1830.98999,
    max_preis_qm_kauf: 6510.870117,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 4504.29509,
    min_preis_qm_kauf: 2827.040039,
    max_preis_qm_kauf: 7480.009766,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 3977.566549,
    min_preis_qm_kauf: 2215.840088,
    max_preis_qm_kauf: 6500,
    name: 'Pankow',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_kauf: 3515.605465,
    min_preis_qm_kauf: 2084.070068,
    max_preis_qm_kauf: 5501.569824,
    name: 'Neukölln',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 4495.560081,
    min_preis_qm_kauf: 2500,
    max_preis_qm_kauf: 8242.379883,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 3061.913535,
    min_preis_qm_kauf: 1802.380005,
    max_preis_qm_kauf: 5492.089844,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 2656.886588,
    min_preis_qm_kauf: 1750,
    max_preis_qm_kauf: 4228.709961,
    name: 'Reinickendorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 5212.946797,
    min_preis_qm_kauf: 2435.219971,
    max_preis_qm_kauf: 9722.219727,
    name: 'Mitte',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 2475.087513,
    min_preis_qm_kauf: 1608.02002,
    max_preis_qm_kauf: 4573.169922,
    name: 'Spandau',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 2805.272955,
    min_preis_qm_kauf: 1524.589966,
    max_preis_qm_kauf: 4242.419922,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 3744.054489,
    min_preis_qm_kauf: 2135.939941,
    max_preis_qm_kauf: 6381.439941,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 3580.419625,
    min_preis_qm_kauf: 1817.569946,
    max_preis_qm_kauf: 5250,
    name: 'Lichtenberg',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 3557.321442,
    min_preis_qm_kauf: 1873.170044,
    max_preis_qm_kauf: 6316.459961,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 4569.570791,
    min_preis_qm_kauf: 2872.629883,
    max_preis_qm_kauf: 7618.009766,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 4070.514183,
    min_preis_qm_kauf: 2332.860107,
    max_preis_qm_kauf: 6959.910156,
    name: 'Pankow',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_kauf: 3618.736087,
    min_preis_qm_kauf: 2080,
    max_preis_qm_kauf: 5500,
    name: 'Neukölln',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 4680.998261,
    min_preis_qm_kauf: 2655.179932,
    max_preis_qm_kauf: 8600,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 2987.94705,
    min_preis_qm_kauf: 1838.98999,
    max_preis_qm_kauf: 4983.330078,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 2791.282681,
    min_preis_qm_kauf: 1823.030029,
    max_preis_qm_kauf: 4274.490234,
    name: 'Reinickendorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 5278.974659,
    min_preis_qm_kauf: 2500,
    max_preis_qm_kauf: 9577.75,
    name: 'Mitte',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 2412.520342,
    min_preis_qm_kauf: 1648.150024,
    max_preis_qm_kauf: 4291.370117,
    name: 'Spandau',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 2867.10639,
    min_preis_qm_kauf: 1696.660034,
    max_preis_qm_kauf: 4205.609863,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 3814.044768,
    min_preis_qm_kauf: 2296.909912,
    max_preis_qm_kauf: 6497.040039,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 3546.830461,
    min_preis_qm_kauf: 1964.290039,
    max_preis_qm_kauf: 5097.149902,
    name: 'Lichtenberg',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 3610.335706,
    min_preis_qm_kauf: 2039.890015,
    max_preis_qm_kauf: 6348.819824,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 4599.566321,
    min_preis_qm_kauf: 2872.629883,
    max_preis_qm_kauf: 8000,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 4095.274226,
    min_preis_qm_kauf: 2303.030029,
    max_preis_qm_kauf: 7023.439941,
    name: 'Pankow',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_kauf: 3759.657635,
    min_preis_qm_kauf: 2239.51001,
    max_preis_qm_kauf: 5800,
    name: 'Neukölln',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 4866.534619,
    min_preis_qm_kauf: 2767.860107,
    max_preis_qm_kauf: 8928.400391,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 3143.94302,
    min_preis_qm_kauf: 1855.52002,
    max_preis_qm_kauf: 5000,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 2949.126908,
    min_preis_qm_kauf: 1871.920044,
    max_preis_qm_kauf: 4366.290039,
    name: 'Reinickendorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 5299.024659,
    min_preis_qm_kauf: 2495.76001,
    max_preis_qm_kauf: 9689.169922,
    name: 'Mitte',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 2691.706675,
    min_preis_qm_kauf: 1701.369995,
    max_preis_qm_kauf: 4844.629883,
    name: 'Spandau',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 2892.315306,
    min_preis_qm_kauf: 1565.380005,
    max_preis_qm_kauf: 4205.609863,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 3914.422524,
    min_preis_qm_kauf: 2387.77002,
    max_preis_qm_kauf: 6764.5,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 3607.146966,
    min_preis_qm_kauf: 2125.51001,
    max_preis_qm_kauf: 5230.77002,
    name: 'Lichtenberg',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 3800.806088,
    min_preis_qm_kauf: 2033.900024,
    max_preis_qm_kauf: 6796.680176,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 4725.827907,
    min_preis_qm_kauf: 2979.5,
    max_preis_qm_kauf: 8114.75,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 4221.19147,
    min_preis_qm_kauf: 2323.080078,
    max_preis_qm_kauf: 7031.25,
    name: 'Pankow',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_kauf: 3783.942121,
    min_preis_qm_kauf: 2304.149902,
    max_preis_qm_kauf: 6000,
    name: 'Neukölln',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 5028.804791,
    min_preis_qm_kauf: 2822.040039,
    max_preis_qm_kauf: 9163.269531,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 3148.388865,
    min_preis_qm_kauf: 1985.290039,
    max_preis_qm_kauf: 5200,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 3090.818901,
    min_preis_qm_kauf: 2007.920044,
    max_preis_qm_kauf: 4433.810059,
    name: 'Reinickendorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 5372.433556,
    min_preis_qm_kauf: 2500,
    max_preis_qm_kauf: 9674.919922,
    name: 'Mitte',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 2685.63342,
    min_preis_qm_kauf: 1737.390015,
    max_preis_qm_kauf: 4782.470215,
    name: 'Spandau',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 2735.098527,
    min_preis_qm_kauf: 1532.26001,
    max_preis_qm_kauf: 4268.529785,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 3955.25713,
    min_preis_qm_kauf: 2438.600098,
    max_preis_qm_kauf: 6887.370117,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 3733.416095,
    min_preis_qm_kauf: 2244.899902,
    max_preis_qm_kauf: 5316.330078,
    name: 'Lichtenberg',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 3868.283775,
    min_preis_qm_kauf: 2134.149902,
    max_preis_qm_kauf: 7130.430176,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 4791.073735,
    min_preis_qm_kauf: 2997.919922,
    max_preis_qm_kauf: 8048.779785,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 4344.187102,
    min_preis_qm_kauf: 2489.629883,
    max_preis_qm_kauf: 7031.25,
    name: 'Pankow',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_kauf: 3739.374308,
    min_preis_qm_kauf: 2304.149902,
    max_preis_qm_kauf: 5956.790039,
    name: 'Neukölln',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 5263.334021,
    min_preis_qm_kauf: 2950,
    max_preis_qm_kauf: 9736.839844,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 3211.457145,
    min_preis_qm_kauf: 2000,
    max_preis_qm_kauf: 5260.830078,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 3151.405979,
    min_preis_qm_kauf: 2071.429932,
    max_preis_qm_kauf: 4483.930176,
    name: 'Reinickendorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 5560.158838,
    min_preis_qm_kauf: 2841.27002,
    max_preis_qm_kauf: 9885.839844,
    name: 'Mitte',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 2838.708957,
    min_preis_qm_kauf: 1806.680054,
    max_preis_qm_kauf: 5070.419922,
    name: 'Spandau',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 2739.727222,
    min_preis_qm_kauf: 1671.030029,
    max_preis_qm_kauf: 4205.609863,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 4124.093839,
    min_preis_qm_kauf: 2443.040039,
    max_preis_qm_kauf: 7294.470215,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 3799.710724,
    min_preis_qm_kauf: 2227.310059,
    max_preis_qm_kauf: 5555.560059,
    name: 'Lichtenberg',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 4007.066422,
    min_preis_qm_kauf: 2209.300049,
    max_preis_qm_kauf: 7369.290039,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 4855.074249,
    min_preis_qm_kauf: 3143.110107,
    max_preis_qm_kauf: 8288.290039,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 4437.000259,
    min_preis_qm_kauf: 2535.030029,
    max_preis_qm_kauf: 7056.75,
    name: 'Pankow',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_kauf: 3922.143841,
    min_preis_qm_kauf: 2536.360107,
    max_preis_qm_kauf: 6208.790039,
    name: 'Neukölln',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 5369.704014,
    min_preis_qm_kauf: 3082.949951,
    max_preis_qm_kauf: 9764.30957,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 3373.351315,
    min_preis_qm_kauf: 2074.310059,
    max_preis_qm_kauf: 5219.779785,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 3123.513157,
    min_preis_qm_kauf: 2000,
    max_preis_qm_kauf: 4479.169922,
    name: 'Reinickendorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 5446.361625,
    min_preis_qm_kauf: 2916.300049,
    max_preis_qm_kauf: 9762.790039,
    name: 'Mitte',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 2842.401857,
    min_preis_qm_kauf: 1843.75,
    max_preis_qm_kauf: 4767.600098,
    name: 'Spandau',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 2910.149184,
    min_preis_qm_kauf: 1887.550049,
    max_preis_qm_kauf: 4280,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 4327.044832,
    min_preis_qm_kauf: 2583.330078,
    max_preis_qm_kauf: 7294.470215,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 3867.691775,
    min_preis_qm_kauf: 2298.76001,
    max_preis_qm_kauf: 5459.560059,
    name: 'Lichtenberg',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 4028.208413,
    min_preis_qm_kauf: 2235.159912,
    max_preis_qm_kauf: 7481.200195,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 4896.614442,
    min_preis_qm_kauf: 3210.530029,
    max_preis_qm_kauf: 8268.969727,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 4603.06053,
    min_preis_qm_kauf: 2604.169922,
    max_preis_qm_kauf: 7636.160156,
    name: 'Pankow',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_kauf: 4400.101954,
    min_preis_qm_kauf: 2632,
    max_preis_qm_kauf: 6700,
    name: 'Neukölln',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 5641.019923,
    min_preis_qm_kauf: 3356.98999,
    max_preis_qm_kauf: 10164.99023,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 3458.082942,
    min_preis_qm_kauf: 2073.540039,
    max_preis_qm_kauf: 5452.990234,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 3178.758539,
    min_preis_qm_kauf: 1959.530029,
    max_preis_qm_kauf: 4611.109863,
    name: 'Reinickendorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 5603.202126,
    min_preis_qm_kauf: 3000,
    max_preis_qm_kauf: 10512.37012,
    name: 'Mitte',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 2923.692189,
    min_preis_qm_kauf: 1953.410034,
    max_preis_qm_kauf: 4844.629883,
    name: 'Spandau',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 2841.095892,
    min_preis_qm_kauf: 1791.359985,
    max_preis_qm_kauf: 4299.879883,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 4501.834865,
    min_preis_qm_kauf: 2685.189941,
    max_preis_qm_kauf: 7611.459961,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 3926.494061,
    min_preis_qm_kauf: 2446.149902,
    max_preis_qm_kauf: 5555.560059,
    name: 'Lichtenberg',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 4144.916481,
    min_preis_qm_kauf: 2318.840088,
    max_preis_qm_kauf: 7217.189941,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 4978.871612,
    min_preis_qm_kauf: 3378.379883,
    max_preis_qm_kauf: 8338.349609,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 4728.483254,
    min_preis_qm_kauf: 2685.280029,
    max_preis_qm_kauf: 7503.950195,
    name: 'Pankow',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_kauf: 4231.82651,
    min_preis_qm_kauf: 2527.27002,
    max_preis_qm_kauf: 6700,
    name: 'Neukölln',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 5776.465981,
    min_preis_qm_kauf: 3438.070068,
    max_preis_qm_kauf: 10371.33984,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 3793.155955,
    min_preis_qm_kauf: 2212.649902,
    max_preis_qm_kauf: 6131.009766,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 3467.403588,
    min_preis_qm_kauf: 2166.669922,
    max_preis_qm_kauf: 5171.819824,
    name: 'Reinickendorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 5852.978621,
    min_preis_qm_kauf: 3007.189941,
    max_preis_qm_kauf: 10631.33984,
    name: 'Mitte',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 3088.205111,
    min_preis_qm_kauf: 2054.790039,
    max_preis_qm_kauf: 4833.330078,
    name: 'Spandau',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 3110.314565,
    min_preis_qm_kauf: 1901.310059,
    max_preis_qm_kauf: 4392.410156,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 4701.983993,
    min_preis_qm_kauf: 2777.780029,
    max_preis_qm_kauf: 7778.450195,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 4100.045958,
    min_preis_qm_kauf: 2647.060059,
    max_preis_qm_kauf: 5993.109863,
    name: 'Lichtenberg',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 4520.897761,
    min_preis_qm_kauf: 2670.669922,
    max_preis_qm_kauf: 7652.169922,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 5065.424521,
    min_preis_qm_kauf: 3433.959961,
    max_preis_qm_kauf: 8455.839844,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 4798.746948,
    min_preis_qm_kauf: 2755.100098,
    max_preis_qm_kauf: 7503.950195,
    name: 'Pankow',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_kauf: 4175.690859,
    min_preis_qm_kauf: 2578.27002,
    max_preis_qm_kauf: 6349.859863,
    name: 'Neukölln',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 5832.436719,
    min_preis_qm_kauf: 3438.070068,
    max_preis_qm_kauf: 10288.36035,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 4112.95272,
    min_preis_qm_kauf: 2357.560059,
    max_preis_qm_kauf: 6806.220215,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 3725.296618,
    min_preis_qm_kauf: 2250,
    max_preis_qm_kauf: 5700,
    name: 'Reinickendorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 5857.651482,
    min_preis_qm_kauf: 2990.570068,
    max_preis_qm_kauf: 10928.69043,
    name: 'Mitte',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 3479.397815,
    min_preis_qm_kauf: 2088.709961,
    max_preis_qm_kauf: 6061.209961,
    name: 'Spandau',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 3202.112257,
    min_preis_qm_kauf: 1730.160034,
    max_preis_qm_kauf: 4570,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 4773.781703,
    min_preis_qm_kauf: 2833.330078,
    max_preis_qm_kauf: 7894.740234,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 4179.399897,
    min_preis_qm_kauf: 2530.120117,
    max_preis_qm_kauf: 6083.819824,
    name: 'Lichtenberg',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 4572.631847,
    min_preis_qm_kauf: 2692.830078,
    max_preis_qm_kauf: 7575.759766,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 5304.523717,
    min_preis_qm_kauf: 3443.449951,
    max_preis_qm_kauf: 8700,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 5005.181624,
    min_preis_qm_kauf: 2956.030029,
    max_preis_qm_kauf: 7928.950195,
    name: 'Pankow',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_kauf: 4208.514956,
    min_preis_qm_kauf: 2596.689941,
    max_preis_qm_kauf: 6599.720215,
    name: 'Neukölln',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 5906.93847,
    min_preis_qm_kauf: 3389.830078,
    max_preis_qm_kauf: 10105.49023,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 4092.857925,
    min_preis_qm_kauf: 2300.830078,
    max_preis_qm_kauf: 7094.939941,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 3749.343107,
    min_preis_qm_kauf: 2251.100098,
    max_preis_qm_kauf: 5700.560059,
    name: 'Reinickendorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 5795.631746,
    min_preis_qm_kauf: 2964.209961,
    max_preis_qm_kauf: 10560.98047,
    name: 'Mitte',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 3153.028287,
    min_preis_qm_kauf: 2064.219971,
    max_preis_qm_kauf: 5293.680176,
    name: 'Spandau',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 3145.55787,
    min_preis_qm_kauf: 1626.02002,
    max_preis_qm_kauf: 5636.359863,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 4878.384007,
    min_preis_qm_kauf: 2850.01001,
    max_preis_qm_kauf: 8409.089844,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 4228.857782,
    min_preis_qm_kauf: 2375,
    max_preis_qm_kauf: 6167.080078,
    name: 'Lichtenberg',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 4627.991417,
    min_preis_qm_kauf: 2685.189941,
    max_preis_qm_kauf: 7727.27002,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 5447.087325,
    min_preis_qm_kauf: 3347.939941,
    max_preis_qm_kauf: 8905.889648,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 5128.662367,
    min_preis_qm_kauf: 3008.399902,
    max_preis_qm_kauf: 7928.950195,
    name: 'Pankow',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_kauf: 4292.870823,
    min_preis_qm_kauf: 2745.030029,
    max_preis_qm_kauf: 6572.540039,
    name: 'Neukölln',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 5959.262264,
    min_preis_qm_kauf: 3431.25,
    max_preis_qm_kauf: 10105.49023,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 4137.913365,
    min_preis_qm_kauf: 2379.27002,
    max_preis_qm_kauf: 7500,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 3812.106754,
    min_preis_qm_kauf: 2419.350098,
    max_preis_qm_kauf: 5743.089844,
    name: 'Reinickendorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 5968.862737,
    min_preis_qm_kauf: 2935.939941,
    max_preis_qm_kauf: 11000,
    name: 'Mitte',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 3460.131465,
    min_preis_qm_kauf: 2181.820068,
    max_preis_qm_kauf: 5945.950195,
    name: 'Spandau',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 3266.29922,
    min_preis_qm_kauf: 1917.040039,
    max_preis_qm_kauf: 5641.470215,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 5054.590352,
    min_preis_qm_kauf: 3050.01001,
    max_preis_qm_kauf: 8731.629883,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 4321.764134,
    min_preis_qm_kauf: 2545.120117,
    max_preis_qm_kauf: 6544.830078,
    name: 'Lichtenberg',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 4598.126013,
    min_preis_qm_kauf: 2762.350098,
    max_preis_qm_kauf: 7489.450195,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 5521.337174,
    min_preis_qm_kauf: 3497.52002,
    max_preis_qm_kauf: 8879.129883,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 5142.253416,
    min_preis_qm_kauf: 3085.629883,
    max_preis_qm_kauf: 7951.709961,
    name: 'Pankow',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_kauf: 4430.679917,
    min_preis_qm_kauf: 2738.100098,
    max_preis_qm_kauf: 6836.589844,
    name: 'Neukölln',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 5964.301856,
    min_preis_qm_kauf: 3451.27002,
    max_preis_qm_kauf: 10076.62988,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 4312.142053,
    min_preis_qm_kauf: 2427.899902,
    max_preis_qm_kauf: 7094.939941,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 3914.205908,
    min_preis_qm_kauf: 2479.340088,
    max_preis_qm_kauf: 6159.649902,
    name: 'Reinickendorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 5951.335113,
    min_preis_qm_kauf: 3136.840088,
    max_preis_qm_kauf: 10744.2002,
    name: 'Mitte',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 3592.989585,
    min_preis_qm_kauf: 2282.610107,
    max_preis_qm_kauf: 5974.140137,
    name: 'Spandau',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 3315.902314,
    min_preis_qm_kauf: 2055,
    max_preis_qm_kauf: 4869.669922,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 5024.288752,
    min_preis_qm_kauf: 3125,
    max_preis_qm_kauf: 8548.610352,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 4572.211141,
    min_preis_qm_kauf: 2572.550049,
    max_preis_qm_kauf: 6813.189941,
    name: 'Lichtenberg',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 4645.363418,
    min_preis_qm_kauf: 2828.570068,
    max_preis_qm_kauf: 7685.890137,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 5528.721614,
    min_preis_qm_kauf: 3590,
    max_preis_qm_kauf: 8709.679688,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 5326.470167,
    min_preis_qm_kauf: 3111.110107,
    max_preis_qm_kauf: 8814.80957,
    name: 'Pankow',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_kauf: 4409.939945,
    min_preis_qm_kauf: 2867.649902,
    max_preis_qm_kauf: 6789.509766,
    name: 'Neukölln',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 6046.391922,
    min_preis_qm_kauf: 3421.350098,
    max_preis_qm_kauf: 10450.15039,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 4339.867391,
    min_preis_qm_kauf: 2494.459961,
    max_preis_qm_kauf: 6876.200195,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 4065.866881,
    min_preis_qm_kauf: 2500,
    max_preis_qm_kauf: 6687.200195,
    name: 'Reinickendorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 6030.212997,
    min_preis_qm_kauf: 3124.860107,
    max_preis_qm_kauf: 11331.16992,
    name: 'Mitte',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 3634.746968,
    min_preis_qm_kauf: 2301.76001,
    max_preis_qm_kauf: 6065.799805,
    name: 'Spandau',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 3591.079746,
    min_preis_qm_kauf: 2423.070068,
    max_preis_qm_kauf: 5171.029785,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 4980.986503,
    min_preis_qm_kauf: 3167.330078,
    max_preis_qm_kauf: 8268.290039,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 4582.890171,
    min_preis_qm_kauf: 2693.879883,
    max_preis_qm_kauf: 6819.02002,
    name: 'Lichtenberg',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 4736.168047,
    min_preis_qm_kauf: 2830.189941,
    max_preis_qm_kauf: 7670,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 5579.160884,
    min_preis_qm_kauf: 3651.300049,
    max_preis_qm_kauf: 8818.19043,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 5458.323347,
    min_preis_qm_kauf: 3177.26001,
    max_preis_qm_kauf: 8756.200195,
    name: 'Pankow',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_kauf: 4463.609355,
    min_preis_qm_kauf: 2928.790039,
    max_preis_qm_kauf: 6979.470215,
    name: 'Neukölln',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 6133.813794,
    min_preis_qm_kauf: 3511.540039,
    max_preis_qm_kauf: 11111.11035,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 4461.170047,
    min_preis_qm_kauf: 2456.449951,
    max_preis_qm_kauf: 7542.529785,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 4077.984687,
    min_preis_qm_kauf: 2552.98999,
    max_preis_qm_kauf: 6934.899902,
    name: 'Reinickendorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 6123.285645,
    min_preis_qm_kauf: 3201.790039,
    max_preis_qm_kauf: 11436.90039,
    name: 'Mitte',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 3784.060437,
    min_preis_qm_kauf: 2359.929932,
    max_preis_qm_kauf: 6445.160156,
    name: 'Spandau',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 3979.980038,
    min_preis_qm_kauf: 2225.050049,
    max_preis_qm_kauf: 5995.97998,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 4928.61757,
    min_preis_qm_kauf: 3200,
    max_preis_qm_kauf: 7940.25,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 4741.709111,
    min_preis_qm_kauf: 2789.120117,
    max_preis_qm_kauf: 6900,
    name: 'Lichtenberg',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 4815.810053,
    min_preis_qm_kauf: 2823.530029,
    max_preis_qm_kauf: 8000,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 5775.199146,
    min_preis_qm_kauf: 3714.179932,
    max_preis_qm_kauf: 9360,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 5585.855606,
    min_preis_qm_kauf: 3333.330078,
    max_preis_qm_kauf: 9008.429688,
    name: 'Pankow',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_kauf: 4663.04725,
    min_preis_qm_kauf: 2979.659912,
    max_preis_qm_kauf: 7163.640137,
    name: 'Neukölln',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 6344.370491,
    min_preis_qm_kauf: 3655.370117,
    max_preis_qm_kauf: 11688.30957,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 4808.772194,
    min_preis_qm_kauf: 2756.629883,
    max_preis_qm_kauf: 8136.649902,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 4387.172852,
    min_preis_qm_kauf: 2723.310059,
    max_preis_qm_kauf: 7484.919922,
    name: 'Reinickendorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 6244.041787,
    min_preis_qm_kauf: 3337.530029,
    max_preis_qm_kauf: 11456.08984,
    name: 'Mitte',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 4144.223802,
    min_preis_qm_kauf: 2466.459961,
    max_preis_qm_kauf: 6589.149902,
    name: 'Spandau',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 4193.371426,
    min_preis_qm_kauf: 2308.139893,
    max_preis_qm_kauf: 6042.859863,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 5039.90118,
    min_preis_qm_kauf: 3419.050049,
    max_preis_qm_kauf: 8023.810059,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 5072.593742,
    min_preis_qm_kauf: 3080.600098,
    max_preis_qm_kauf: 8029.350098,
    name: 'Lichtenberg',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 4958.695311,
    min_preis_qm_kauf: 2899.689941,
    max_preis_qm_kauf: 8194.44043,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 5943.648351,
    min_preis_qm_kauf: 3856.360107,
    max_preis_qm_kauf: 9698.05957,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 5751.832271,
    min_preis_qm_kauf: 3446.399902,
    max_preis_qm_kauf: 9432.879883,
    name: 'Pankow',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_kauf: 4779.878399,
    min_preis_qm_kauf: 3049.669922,
    max_preis_qm_kauf: 7556.879883,
    name: 'Neukölln',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 6406.410475,
    min_preis_qm_kauf: 3750,
    max_preis_qm_kauf: 11809.08984,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 4869.585821,
    min_preis_qm_kauf: 2900,
    max_preis_qm_kauf: 8079.370117,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 4422.540039,
    min_preis_qm_kauf: 2833.330078,
    max_preis_qm_kauf: 7484.919922,
    name: 'Reinickendorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 6330.64193,
    min_preis_qm_kauf: 3416.830078,
    max_preis_qm_kauf: 12037.04004,
    name: 'Mitte',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 4493.771416,
    min_preis_qm_kauf: 2631.580078,
    max_preis_qm_kauf: 6978.490234,
    name: 'Spandau',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 4284.493554,
    min_preis_qm_kauf: 2466.820068,
    max_preis_qm_kauf: 6864.180176,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 5088.246689,
    min_preis_qm_kauf: 3490.070068,
    max_preis_qm_kauf: 8268.290039,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 5149.219907,
    min_preis_qm_kauf: 3078.429932,
    max_preis_qm_kauf: 7560.97998,
    name: 'Lichtenberg',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 5114.997396,
    min_preis_qm_kauf: 3009.52002,
    max_preis_qm_kauf: 8644.160156,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 6125.096355,
    min_preis_qm_kauf: 3932.330078,
    max_preis_qm_kauf: 10332.66016,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 5958.918913,
    min_preis_qm_kauf: 3540.040039,
    max_preis_qm_kauf: 9802.269531,
    name: 'Pankow',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_kauf: 4944.417547,
    min_preis_qm_kauf: 3075,
    max_preis_qm_kauf: 7800,
    name: 'Neukölln',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 6603.924261,
    min_preis_qm_kauf: 3880.469971,
    max_preis_qm_kauf: 12148.65039,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 5164.620603,
    min_preis_qm_kauf: 3000,
    max_preis_qm_kauf: 8264.459961,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 4231.021022,
    min_preis_qm_kauf: 2833.330078,
    max_preis_qm_kauf: 6879.189941,
    name: 'Reinickendorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 6609.16951,
    min_preis_qm_kauf: 3426.76001,
    max_preis_qm_kauf: 13296.75,
    name: 'Mitte',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 4500.521238,
    min_preis_qm_kauf: 2740.540039,
    max_preis_qm_kauf: 7038.029785,
    name: 'Spandau',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 4097.285448,
    min_preis_qm_kauf: 2577.090088,
    max_preis_qm_kauf: 5995.97998,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 5113.907588,
    min_preis_qm_kauf: 3413.830078,
    max_preis_qm_kauf: 8177.060059,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 5229.408081,
    min_preis_qm_kauf: 3278.47998,
    max_preis_qm_kauf: 8186.399902,
    name: 'Lichtenberg',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 5245.993281,
    min_preis_qm_kauf: 3177.570068,
    max_preis_qm_kauf: 8500,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 6323.804529,
    min_preis_qm_kauf: 4010.310059,
    max_preis_qm_kauf: 10869.57031,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 6119.59304,
    min_preis_qm_kauf: 3511.23999,
    max_preis_qm_kauf: 10376.36035,
    name: 'Pankow',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_kauf: 5000.041631,
    min_preis_qm_kauf: 3107.689941,
    max_preis_qm_kauf: 7851.060059,
    name: 'Neukölln',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 6724.568663,
    min_preis_qm_kauf: 3986.330078,
    max_preis_qm_kauf: 12500,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 5215.841617,
    min_preis_qm_kauf: 3173.080078,
    max_preis_qm_kauf: 8264.459961,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 4276.21967,
    min_preis_qm_kauf: 3013.27002,
    max_preis_qm_kauf: 6837.100098,
    name: 'Reinickendorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 6780.637795,
    min_preis_qm_kauf: 3472.219971,
    max_preis_qm_kauf: 13149.19043,
    name: 'Mitte',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 4400.885517,
    min_preis_qm_kauf: 2574.040039,
    max_preis_qm_kauf: 7058.819824,
    name: 'Spandau',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 4156.383085,
    min_preis_qm_kauf: 2577.090088,
    max_preis_qm_kauf: 6101.959961,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 5245.726596,
    min_preis_qm_kauf: 3500,
    max_preis_qm_kauf: 8507.849609,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 5270.243258,
    min_preis_qm_kauf: 3278.47998,
    max_preis_qm_kauf: 8033.359863,
    name: 'Lichtenberg',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 5271.71931,
    min_preis_qm_kauf: 3021.97998,
    max_preis_qm_kauf: 8811.759766,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 6608.995569,
    min_preis_qm_kauf: 4142.790039,
    max_preis_qm_kauf: 11467.50977,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_kauf: 6220.647208,
    min_preis_qm_kauf: 3611.830078,
    max_preis_qm_kauf: 10209.83984,
    name: 'Pankow',
    zeit: '2021-Q4',
  },
]
